export const DEFAULT_API_URL = "https://goodness.mcp.key-axis.com";
